import { HttpClient } from '@angular/common/http';
// import { environment } from '../../../../environments/environment';
import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../config/config.service";
var AlertHttpService = /** @class */ (function () {
    function AlertHttpService(http, configService) {
        this.http = http;
        this.configService = configService;
        this.apiName = this.configService.get('host');
    }
    AlertHttpService.prototype.initMachine = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/init_machine';
            var params = {
                body: formObj
            };
            API.post(_this.apiName, path, params).then(function (resp) {
                observer.next(resp);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    AlertHttpService.prototype.getIssueReason = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/oiclearreasons';
            var params = {
                response: false
            };
            API.get(_this.apiName, path, params).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    AlertHttpService.prototype.clearOI = function (obj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/clearoi';
            var params = {
                body: obj
            };
            API.post(_this.apiName, path, params).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    AlertHttpService.prototype.getOpenIssues = function (m_id) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_open_issues/' + m_id;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    AlertHttpService.prototype.getMachineLogs = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path;
            if (queryParams.optFilterVal === 'evt') {
                path = '/dashboard/get_events';
            }
            else {
                path = '/dashboard/get_logs';
            }
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    AlertHttpService.prototype.getMacLogCodes = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_log_code_dict';
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (log_codes) {
                var _a;
                var payLoad = {};
                var result = [];
                for (var _i = 0, _b = log_codes.data; _i < _b.length; _i++) {
                    var code = _b[_i];
                    if (!result[code.occOrRes]) {
                        result[code.occOrRes] = (_a = {}, _a[code.log_code] = code.log_msg, _a);
                    }
                    else {
                        result[code.occOrRes][code.log_code] = code.log_msg;
                    }
                }
                console.log(result);
                payLoad.processed = result;
                payLoad.raw = log_codes.data;
                observer.next(payLoad);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    AlertHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AlertHttpService_Factory() { return new AlertHttpService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: AlertHttpService, providedIn: "root" });
    return AlertHttpService;
}());
export { AlertHttpService };
